module.exports = __webpack_public_path__ + "img/location.b44e0015.svg";